export default __webpack_public_path__ + "static/media/DarkBlue0001.d3e54e47.png";